import { Stack, Typography } from '@mui/material';
import { LAYOUT_DEFAULTS } from '../../../../../utils/constants';
import PositionAccoridions, { IPositionAccordionsItem } from './componets/PositionAccoridions';
import SeniorCustomerGrowthSpecialist from './componets/SeniorCustomerGrowthSpecialist';
import JuniorCustomerGrowthSpecialist from './componets/JuniorCustomerGrowthSpecialist';
import SalesRepresentivePerformance from './componets/SalesRepresentivePerformance';
import SalesRepresentivePMTool from './componets/SalesRepresentivePMTool';

const positions: IPositionAccordionsItem[] = [
  {
    summary: 'Sales Development Representative – Spona Performance',
    details: <SalesRepresentivePerformance />,
  },
  {
    summary: 'Sales Development Representative – Spona Project Management Tool',
    details: <SalesRepresentivePMTool />,
  },
  {
    summary: 'Senior Customer Growth Manager',
    details: <SeniorCustomerGrowthSpecialist />,
  },
  { summary: 'Junior Customer Growth Manager', details: <JuniorCustomerGrowthSpecialist /> },
];

const OpenPositions = () => (
  <Stack spacing={4} sx={{ ...LAYOUT_DEFAULTS, mb: 16 }}>
    <Typography variant="publicHeading3">Open Positions | Dublin, Ireland</Typography>
    <PositionAccoridions items={positions} />
  </Stack>
);
export default OpenPositions;
